module.exports = __webpack_public_path__ + "img/category.575c6b5a.svg";